//import { FormGroupInput } from "../components/index";
/**
 * You can register global components here and use them as a plugin in your main Vue instance
 */


const GlobalComponents = {
    install(Vue) {
        //Vue.component("fg-input", FormGroupInput);
    }
};

export default GlobalComponents;



// WEBPACK FOOTER //
// ./src/plugins/globalComponents.js